import { z } from 'zod/v4';

import { normalizeAccordionWidgetArgs } from './accordion-widget-args.normalization';
import { partialAccordionWidgetDataSchema } from './partial-accordion-widget-data.schema';

const updateAccordionWidgetObjectSchema = z.object({
    widgetId: z.string().describe('Id of the accordion widget to update.'),
    data: partialAccordionWidgetDataSchema.describe(
        'Partial patch — only the fields you provide are changed, everything else is left as-is. ' +
            '"accordionList", if provided, replaces the whole list.'
    ),
});

export const updateAccordionWidgetArgsSchema = z.preprocess(
    normalizeAccordionWidgetArgs,
    updateAccordionWidgetObjectSchema
);
